// Years: newest first
export const CAR_YEARS = Array.from({ length: 2026 - 1990 + 1 }, (_, i) => String(2026 - i));

// Makes and their models
export const CAR_MAKES = [
  'Acura',
  'Alfa Romeo',
  'Aston Martin',
  'Audi',
  'Bentley',
  'BMW',
  'Buick',
  'Cadillac',
  'Chevrolet',
  'Chrysler',
  'Dodge',
  'Ferrari',
  'Fiat',
  'Ford',
  'Genesis',
  'GMC',
  'Honda',
  'Hyundai',
  'Infiniti',
  'Jaguar',
  'Jeep',
  'Kia',
  'Lamborghini',
  'Land Rover',
  'Lexus',
  'Lincoln',
  'Lucid',
  'Maserati',
  'Mazda',
  'McLaren',
  'Mercedes-Benz',
  'MINI',
  'Mitsubishi',
  'Nissan',
  'Polestar',
  'Porsche',
  'Ram',
  'Rivian',
  'Rolls-Royce',
  'Subaru',
  'Tesla',
  'Toyota',
  'Volkswagen',
  'Volvo',
  'Other',
];

export const CAR_MODELS = {
  'Acura': ['ILX', 'Integra', 'MDX', 'NSX', 'RDX', 'RLX', 'TL', 'TLX', 'TSX', 'ZDX', 'Other'],
  'Alfa Romeo': ['4C', 'Giulia', 'Giulietta', 'Stelvio', 'Tonale', 'Other'],
  'Aston Martin': ['DB11', 'DB12', 'DBS', 'DBX', 'Vantage', 'Other'],
  'Audi': ['A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'e-tron', 'e-tron GT', 'Q3', 'Q4 e-tron', 'Q5', 'Q7', 'Q8', 'R8', 'RS3', 'RS5', 'RS6', 'RS7', 'S3', 'S4', 'S5', 'S6', 'S7', 'TT', 'Other'],
  'Bentley': ['Bentayga', 'Continental GT', 'Flying Spur', 'Mulsanne', 'Other'],
  'BMW': ['1 Series', '2 Series', '3 Series', '4 Series', '5 Series', '6 Series', '7 Series', '8 Series', 'i3', 'i4', 'i7', 'i8', 'iX', 'iX3', 'M2', 'M3', 'M4', 'M5', 'M8', 'X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'X7', 'Z4', 'Other'],
  'Buick': ['Cascada', 'Enclave', 'Encore', 'Encore GX', 'Envision', 'LaCrosse', 'Regal', 'Verano', 'Other'],
  'Cadillac': ['ATS', 'CT4', 'CT5', 'CT6', 'Escalade', 'Lyriq', 'SRX', 'XT4', 'XT5', 'XT6', 'XTS', 'Other'],
  'Chevrolet': ['Blazer', 'Bolt EUV', 'Bolt EV', 'Camaro', 'Colorado', 'Corvette', 'Equinox', 'Express', 'Impala', 'Malibu', 'Silverado 1500', 'Silverado 2500HD', 'Silverado 3500HD', 'Sonic', 'Spark', 'Suburban', 'Tahoe', 'Trailblazer', 'Traverse', 'Trax', 'Other'],
  'Chrysler': ['300', 'Pacifica', 'Voyager', 'Other'],
  'Dodge': ['Challenger', 'Charger', 'Dart', 'Durango', 'Grand Caravan', 'Hornet', 'Journey', 'Other'],
  'Ferrari': ['296 GTB', '488 GTB', '488 Pista', 'F8 Tributo', 'GTC4Lusso', 'Portofino', 'Roma', 'SF90 Stradale', 'Other'],
  'Fiat': ['124 Spider', '500', '500e', '500L', '500X', 'Other'],
  'Ford': ['Bronco', 'Bronco Sport', 'E-Transit', 'EcoSport', 'Edge', 'Escape', 'Expedition', 'Explorer', 'F-150', 'F-150 Lightning', 'F-250 Super Duty', 'F-350 Super Duty', 'Fusion', 'Maverick', 'Mustang', 'Mustang Mach-E', 'Ranger', 'Taurus', 'Transit', 'Other'],
  'Genesis': ['G70', 'G80', 'G90', 'GV70', 'GV80', 'GV90', 'Other'],
  'GMC': ['Acadia', 'Canyon', 'Envoy', 'Sierra 1500', 'Sierra 2500HD', 'Sierra 3500HD', 'Terrain', 'Yukon', 'Yukon XL', 'Other'],
  'Honda': ['Accord', 'Clarity', 'CR-V', 'CR-Z', 'Fit', 'HR-V', 'Insight', 'Odyssey', 'Passport', 'Pilot', 'Prologue', 'Ridgeline', 'Other'],
  'Hyundai': ['Accent', 'Elantra', 'IONIQ', 'IONIQ 5', 'IONIQ 6', 'Kona', 'Palisade', 'Santa Cruz', 'Santa Fe', 'Sonata', 'Tucson', 'Venue', 'Other'],
  'Infiniti': ['Q50', 'Q60', 'Q70', 'QX50', 'QX55', 'QX60', 'QX80', 'Other'],
  'Jaguar': ['E-PACE', 'F-PACE', 'F-TYPE', 'I-PACE', 'XE', 'XF', 'XJ', 'Other'],
  'Jeep': ['Cherokee', 'Compass', 'Gladiator', 'Grand Cherokee', 'Grand Cherokee L', 'Grand Wagoneer', 'Renegade', 'Wagoneer', 'Wrangler', 'Other'],
  'Kia': ['Carnival', 'EV6', 'EV9', 'Forte', 'K5', 'Niro', 'Seltos', 'Soul', 'Sorento', 'Sportage', 'Stinger', 'Telluride', 'Other'],
  'Lamborghini': ['Aventador', 'Huracan', 'Urus', 'Other'],
  'Land Rover': ['Defender', 'Discovery', 'Discovery Sport', 'Freelander', 'Range Rover', 'Range Rover Evoque', 'Range Rover Sport', 'Range Rover Velar', 'Other'],
  'Lexus': ['ES', 'GS', 'GX', 'IS', 'LC', 'LS', 'LX', 'NX', 'RC', 'RX', 'RZ', 'TX', 'UX', 'Other'],
  'Lincoln': ['Aviator', 'Corsair', 'MKC', 'MKX', 'MKZ', 'Nautilus', 'Navigator', 'Other'],
  'Lucid': ['Air', 'Gravity', 'Other'],
  'Maserati': ['Ghibli', 'GranTurismo', 'Grecale', 'Levante', 'Quattroporte', 'Other'],
  'Mazda': ['CX-30', 'CX-5', 'CX-50', 'CX-60', 'CX-70', 'CX-90', 'Mazda3', 'Mazda6', 'MX-5 Miata', 'MX-30', 'Other'],
  'McLaren': ['570S', '600LT', '720S', '765LT', 'Artura', 'GT', 'Other'],
  'Mercedes-Benz': ['A-Class', 'AMG GT', 'C-Class', 'CLA', 'CLE', 'CLS', 'E-Class', 'EQB', 'EQC', 'EQE', 'EQS', 'G-Class', 'GLA', 'GLB', 'GLC', 'GLE', 'GLS', 'S-Class', 'SL', 'SLC', 'Sprinter', 'Other'],
  'MINI': ['Clubman', 'Convertible', 'Countryman', 'Coupe', 'Hardtop', 'Paceman', 'Roadster', 'Other'],
  'Mitsubishi': ['Eclipse Cross', 'Galant', 'i-MiEV', 'Lancer', 'Mirage', 'Outlander', 'Outlander PHEV', 'Outlander Sport', 'Other'],
  'Nissan': ['Altima', 'Armada', 'Frontier', 'LEAF', 'Maxima', 'Murano', 'Pathfinder', 'Rogue', 'Rogue Sport', 'Sentra', 'Titan', 'Versa', 'Other'],
  'Polestar': ['1', '2', '3', '4', 'Other'],
  'Porsche': ['718 Boxster', '718 Cayman', '911', 'Cayenne', 'Macan', 'Panamera', 'Taycan', 'Other'],
  'Ram': ['1500', '2500', '3500', 'ProMaster', 'ProMaster City', 'Other'],
  'Rivian': ['R1S', 'R1T', 'R2', 'Other'],
  'Rolls-Royce': ['Cullinan', 'Dawn', 'Ghost', 'Phantom', 'Spectre', 'Wraith', 'Other'],
  'Subaru': ['Ascent', 'BRZ', 'Crosstrek', 'Forester', 'Impreza', 'Legacy', 'Outback', 'Solterra', 'WRX', 'Other'],
  'Tesla': ['Cybertruck', 'Model 3', 'Model S', 'Model X', 'Model Y', 'Roadster', 'Other'],
  'Toyota': ['4Runner', 'Avalon', 'bZ4X', 'Camry', 'C-HR', 'Corolla', 'Crown', 'GR86', 'GR Corolla', 'GR Supra', 'Highlander', 'Land Cruiser', 'Mirai', 'Prius', 'Prius Prime', 'RAV4', 'RAV4 Prime', 'Sequoia', 'Sienna', 'Tacoma', 'Tundra', 'Venza', 'Other'],
  'Volkswagen': ['Arteon', 'Atlas', 'Atlas Cross Sport', 'Golf', 'Golf GTI', 'Golf R', 'ID.4', 'ID.Buzz', 'Jetta', 'Passat', 'Taos', 'Tiguan', 'Other'],
  'Volvo': ['C40 Recharge', 'S60', 'S90', 'V60', 'V90', 'XC40', 'XC40 Recharge', 'XC60', 'XC90', 'Other'],
  'Other': [],
};
